import styled from "@emotion/styled";
import { Colors, Spacing } from "@snapchat/snap-design-system";

export const AvailabilityDetailsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${Spacing.XS}px;

    padding: ${Spacing.MD}px;

    background-color: ${Colors.Gray.V50};
    border-radius: 8px;
`;
